import type { Topic } from 'pages/ParentHelper/types';

export const sortChatsByFavorite = (value: Topic) =>
  value.isFavorite ? -1 : 1;
